import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../applicationUi/components/Table";
import BlockDetailsModal from "../../modals/BlockDetailsModal";
import { fetchBlocksByClient } from "../../store/thunks/blocksThunk";

const ClientBlocks = () => {
  const dispatch = useDispatch();
  const [selectedBlock, setSelectedBlock] = useState(null);

  const client = useSelector((state) => state.clients.selectedClient);
  const blocks = useSelector((state) => state.blocks.clientBlocks || []);
  const error = useSelector((state) => state.blocks.error);
//   const loadingClientBlocks = useSelector(
//     (state) => state.blocks.loadingClientBlocks
//   );

  useEffect(() => {
    if (client?._id) {
      dispatch(fetchBlocksByClient(client._id));
    }
  }, [client, dispatch]);

  useEffect(() => {
    if (selectedBlock) {
      const updatedBlock = blocks.find((b) => b._id === selectedBlock._id);
      // Only update if something actually changed (you might need a deeper check)
      if (updatedBlock && updatedBlock !== selectedBlock) {
        setSelectedBlock(updatedBlock);
      }
    }
  }, [blocks]);

  const handleRowClick = (block) => {
    setSelectedBlock(block); // Persist selected block
  };

//   if (loadingClientBlocks) {
//     return <div className="p-4 text-gray-600">Loading blocks...</div>;
//   }

  if (!blocks || blocks.length === 0) {
    return (
      <div className="bg-white rounded-sm shadow-sm border border-gray-200 p-6">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-sm bg-gray-100">
            <svg className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          <h3 className="mt-2 text-sm font-medium text-gray-900">No blocks found</h3>
          <p className="mt-1 text-sm text-gray-500">No blocks found for this client.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Table
        columns={[
          { header: "Title", accessor: "title" },
          {
            header: "Num Sessions",
            accessor: (row) => row.appointments.length,
          },
          {
            header: "Previous Block",
            accessor: (row) =>
              row.previousBlock ? `${row.previousBlock.title} ` : "None",
          },
          {
            header: "Next Block",
            accessor: (row) =>
              row.nextBlock ? `${row.nextBlock.title}` : "None",
          },
        ]}
        data={blocks}
        title="Client Blocks"
        description={`Block sequences for ${client?.firstName} ${client?.lastName}`}
        onRowClick={(id) => {
          const found = blocks.find((b) => b._id === id);
          handleRowClick(found);
        }}
      />

      {selectedBlock && (
        <BlockDetailsModal
          isOpen={true}
          blockId={selectedBlock._id}
          onClose={() => {
            setSelectedBlock(null);
            dispatch(fetchBlocksByClient(client._id));
          }}
        />
      )}
    </div>
  );
};

export default ClientBlocks;
